import React from 'react';
import './ArtistTierBadge.css';

interface ArtistTierBadgeProps {
  tier?: string | null;
  size?: 'small' | 'medium';
}

export function tierCssClass(tier: string): string {
  return tier
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

const ArtistTierBadge: React.FC<ArtistTierBadgeProps> = ({ tier, size = 'small' }) => {
  if (!tier) return null;
  return (
    <span className={`artist-tier-badge artist-tier-badge--${size} artist-tier-badge--${tierCssClass(tier)}`}>
      {tier}
    </span>
  );
};

export default ArtistTierBadge;
